import { useQuery } from '@tanstack/react-query'
import { configApi } from '../lib/api'
import type { Limits, ReadCaps } from '../types/config'

/**
 * The caps this server enforces (SC-4). Instance-wide, so the key is deliberately NOT scoped to
 * the acting committee (unlike useClientConfig) -- caps do not vary per committee. Values are
 * fixed for the server process's lifetime, so staleTime is Infinity.
 *
 * Callers use this for PRE-FLIGHT WARNINGS ONLY. The server cap is the only gate.
 */
export function useLimits() {
  return useQuery<Limits>({
    queryKey: ['config', 'limits'],
    queryFn: () => configApi.getLimits().then((r) => r.data),
    staleTime: Infinity,
  })
}

/**
 * The six read caps, or `undefined` while loading or on error. Returning `undefined` rather than a
 * hard-coded fallback is deliberate: a caller that cannot learn the cap must show NO warning and
 * submit normally (fail open on messaging; the server still fails closed).
 */
export function useReadCaps(): ReadCaps | undefined {
  return useLimits().data?.readCaps
}
